/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

import {DailySeries} from 'features/mediaplan-progress/types';

export const planSeriesFromChartData = (data: CommonChartData[]): DailySeries =>
  data.reduce<DailySeries>((acc, point) => {
    if (point.line !== undefined) {
      acc[point.name] = point.line;
    }
    return acc;
  }, {});

export const factSeriesFromChartData = (data: CommonChartData[]): DailySeries =>
  data.reduce<DailySeries>((acc, point) => {
    if (point.primary !== undefined && !point.hide) {
      acc[point.name] = point.primary;
    }
    return acc;
  }, {});

// Граница «сегодня» = последняя точка с truthy primary (как легаси statsCumulativePlanAtToday:
// `cur.primary` — truthy, поэтому primary: 0 границей не считается, hide игнорируется).
// Обратный цикл, а не Array.findLast — последний не во всех целевых браузерах (browserslist
// production шире ES2023, полифиллов нет).
export const lastFactKey = (data: CommonChartData[]): string | undefined => {
  for (let i = data.length - 1; i >= 0; i--) {
    if (data[i].primary) {
      return data[i].name;
    }
  }
  return undefined;
};
